export default __webpack_public_path__ + "static/media/open_face_new.a945a678.png";